import {breakpoints} from '../constants/breakpoints';
import STATE from '../constants/state';

const handleMenuAccordion = () => {
  const selectors = {
    item: '.js-accordion',
    subMenu: '.js-submenu',
    inner: '.js-submenu-list',
    link: '.js-accordion-link',
  };

  if (window.innerWidth > breakpoints.tablet) return;

  const elems = [...document.querySelectorAll(selectors.item)];
  const links = [...document.querySelectorAll(selectors.link)];

  const hideAllElems = () => {
    elems.forEach((elem) => {
      const subMenu = elem.querySelector(selectors.subMenu);
      const subMenuLink = elem.querySelector(selectors.link);

      subMenu.style.height = 0;
      subMenuLink.classList.remove(STATE.active);
    });
  };

  const openSubMenu = ({e, elem}) => {
    const subMenu = elem.querySelector(selectors.subMenu);
    const subMenuInner = elem.querySelector(selectors.inner);
    const subMenuLink = elem.querySelector(selectors.link);

    // Condition checking has to be before calling the hideAllElems function
    const wasTheSameElClickedTwice =
      subMenuLink.classList.contains(STATE.active) &&
      !e.target.closest(selectors.subMenu);

    hideAllElems();

    if (wasTheSameElClickedTwice) return;

    subMenuLink.classList.add(STATE.active);
    subMenu.style.height = subMenuInner.offsetHeight + 'px';
  };

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
    });
  });

  elems.forEach((elem) => {
    elem.addEventListener('click', (e) => openSubMenu({e, elem}));
  });
};

export default handleMenuAccordion;
